import React from 'react';

// Signature motif: a small equalizer of synchronized bars — the "synchronic"
// idea made visual. Used in the logo lockup and the hero console.
export default function SyncBars({ count = 5, className = '', barClassName = '' }) {
  const delays = ['0s', '0.18s', '0.36s', '0.12s', '0.28s', '0.42s', '0.06s'];
  const heights = ['60%', '100%', '45%', '85%', '70%', '95%', '55%'];
  return (
    <div
      className={`flex items-end gap-[3px] ${className}`}
      aria-hidden="true"
    >
      {Array.from({ length: count }).map((_, i) => (
        <span
          key={i}
          className={`syncbar w-[3px] ${barClassName}`}
          style={{ height: heights[i % heights.length], animationDelay: delays[i % delays.length] }}
        />
      ))}
    </div>
  );
}
